export default "/assets/images/2022aug/footer_text.svg"